import { render, staticRenderFns } from "./TwSetSection.vue?vue&type=template&id=e02470f4&scoped=true&"
import script from "./TwSetSection.vue?vue&type=script&lang=js&"
export * from "./TwSetSection.vue?vue&type=script&lang=js&"
import style0 from "./TwSetSection.vue?vue&type=style&index=0&id=e02470f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02470f4",
  null
  
)

export default component.exports